"use strict";
'use es6'; // const CRM_BENDER_PROJECT_NAME = 'crm-records-ui';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var CONVERSATIONS_BENDER_PROJECT_NAME = 'conversations-inbox-ui';
var PLAYBOOKS_BENDER_PROJECT_NAME = 'playbooks-admin-ui';
var USER_PREFERENCES_BENDER_PROJECT_NAME = 'UserPreferencesUI';
var DOCUMENTS_BENDER_PROJECT_NAME = 'documents-ui';
var _default = [// CRM_BENDER_PROJECT_NAME,
CONVERSATIONS_BENDER_PROJECT_NAME, USER_PREFERENCES_BENDER_PROJECT_NAME, // 'file-manager-demo-ui',
PLAYBOOKS_BENDER_PROJECT_NAME, DOCUMENTS_BENDER_PROJECT_NAME];
exports.default = _default;
module.exports = exports.default;